import Map from '../helpers/Map';

/*$(document).ready(function (){
	ymaps.ready(function(){Map.i($('#map'))});
});*/


function loadScript(url, callback){
	var script = document.createElement("script");

	if (script.readyState){  // IE
		script.onreadystatechange = function(){
	if (script.readyState == "loaded" ||
		script.readyState == "complete"){
		script.onreadystatechange = null;
		callback();
}
};
} else { // others
	script.onload = function(){
	callback();
};
}

	script.src = url;
	document.getElementsByTagName("head")[0].appendChild(script);
}

	document.addEventListener("DOMContentLoaded", function() {
	setTimeout(function(){

		loadScript("https://api-maps.yandex.ru/2.1/?lang=ru_RU" ,
			function(){ ye();});
	},4000);
});
function ye(){
	ymaps.ready(function(){Map.i($('#map'))});
}
